
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Table,
  UncontrolledDropdown,
} from "reactstrap";
import MeetingReportService from "../../../services/meetingReportService";
import NotificationAlert from "react-notification-alert";
import ReactBSAlert from "react-bootstrap-sweetalert";
import FormInput from "../../../components/common/form/FormInput";
import _ from "lodash";
import {ContentPermissions, MeetingReportPermissions} from "../../../services/permissions";
import routeVisibleForRole from "../../../util/routeVisibleForRole";
import formatFrontendDate from "../util/formatFrontendDate";

class MeetingList extends React.Component {
  constructor(props) {
    super(props);
    
    // Calculate last 7 days including today
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 6); // 6 days back + today = 7 days
    
    const dateFrom = sevenDaysAgo.toISOString().split('T')[0];
    const dateTo = today.toISOString().split('T')[0];
    
    this.state = {
      list: [],
      mainList: [],
      alert: null,
      dateFrom: dateFrom,
      dateTo: dateTo,
      countryName: "",
      companyName: ""
    };
    this.delete = this.delete.bind(this);
    this.notify = this.notify.bind(this);
    this.onChange = this.onChange.bind(this);
    this.clearFilters = this.clearFilters.bind(this);
    this.filterMeetingReports = this.filterMeetingReports.bind(this);
  }

  getDefaultDateRange = () => {
    // Last 7 days including today
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 6); // 6 days back + today = 7 days
    
    return {
      dateFrom: sevenDaysAgo.toISOString().split('T')[0],
      dateTo: today.toISOString().split('T')[0]
    };
  };

  componentDidMount() {
    this.fetchReports(this.state.dateFrom, this.state.dateTo);
  }

  fetchReports = (dateFrom, dateTo) => {
    MeetingReportService.list(dateFrom, dateTo).then((response) => {
      console.log(response);
      let data = response;
      if (routeVisibleForRole(["ROLE_LEVEL3"])) {
        data = this.filterByUserId(data, localStorage.getItem('userId'));
      }
      this.setState({ list: data, mainList: data });
    });
  };

  filterByUserId = (data, userId) => {
    return _.filter(data, obj => obj?.createdBy === userId);
  };

  onChange(event) {
    this.setState({[event.target.name]: event.target.value});
    console.log(this.state);
  }

  clearFilters = (event) => {
    const { dateFrom, dateTo } = this.getDefaultDateRange();
    this.setState({ 
      dateFrom, 
      dateTo, 
      countryName: "", 
      companyName: "" 
    }, () => {
      this.fetchReports(dateFrom, dateTo);
    });
  };


  hideDeleteAlert = () => {
    this.setState({
      alert: null
    });
  };

  confirmDeleteAlert = (uniqueId) => {
    this.setState({
      alert: (
          <ReactBSAlert
              warning
              style={{display: "block"}}
              title="Are you sure?"
              onConfirm={() => this.delete(uniqueId)}
              onCancel={this.hideDeleteAlert}
              showCancel
              confirmBtnBsStyle="danger"
              confirmBtnText="Yes, delete it!"
              cancelBtnBsStyle="secondary"
              cancelBtnText="Cancel"
              btnSize=""
          >
            You won't be able to revert this!
          </ReactBSAlert>
      )
    });
  };

  delete(uniqueId) {
    this.setState({alert: null})
    MeetingReportService.delete(uniqueId).then((response) => {
      console.log(response);
      this.notify(
          response.responseStatus.toLowerCase(),
          response.responseStatus,
          response.message
      );
      //TODO: TO be fixed with redux implementation
      //   this.props.history.push("/admin/dashboard");
      // Refresh list with current date filters
      this.fetchReports(this.state.dateFrom, this.state.dateTo);
    });
  }

  notify = (type, title, message) => {
    let options = {
      place: "tc",
      message: (
          <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
            <span data-notify="message">{message}</span>
          </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5,
    };
    this.refs.notificationAlert.notificationAlert(options);
  };

  filterMeetingReports = () => {
    console.log("Hi from filterMeetingReports");
    const { countryName, companyName, dateFrom, dateTo } = this.state;
    console.log(this.state);
    
    // Fetch data from server with date filters
    MeetingReportService.list(dateFrom, dateTo).then((response) => {
      let data = response;
      if (routeVisibleForRole(["ROLE_LEVEL3"])) {
        data = this.filterByUserId(data, localStorage.getItem('userId'));
      }
      
      // Apply client-side filters (company, country)
      const filteredList = _.filter(data, (report) => {
        const reportCompany = _.get(report, 'company', {});
        const countryMatch = countryName 
          ? reportCompany?.country?.toLowerCase().includes(countryName.toLowerCase()) 
          : true;
        const companyNameMatch = companyName 
          ? reportCompany?.legalName?.toLowerCase().includes(companyName.toLowerCase()) 
          : true;
        return countryMatch && companyNameMatch;
      });
      
      this.setState({ list: filteredList, mainList: data });
    });
  };

  render() {
    let obj = this;
    return (
        <>
          <div className="rna-wrapper">
            <NotificationAlert ref="notificationAlert"/>
          </div>
          <SimpleHeader
              name="List"
              parentName="Meeting Report"
              heading="XareGrwoth"
              newBtnUrl="/crm/meetingReport/create"
              newBtnText="Create Meeting Report"
          />
          {this.state.alert}
          <Container className="mt--6" fluid>
            <Row>
              <Col xl="12">
                <Card>
                  <CardHeader className="border-0">
                    <Row className="align-items-center">
                      <div className="col">
                        <h3 className="mb-0">Meeting Report List</h3>
                      </div>
                    </Row>
                    <Row>
                      <p style={{ fontStyle: "italic", color: "gray" }}>
                        Use the filters below to narrow down your search results.
                      </p>
                    </Row>
                    <Row>
                      <Col sm={2}>
                        <FormInput
                            name="dateFrom"
                            className="form-control-label"
                            id="date"
                            placeholder="inputPlaceHolder.meetingReport.date"
                            type="date"
                            onChange={this.onChange}
                            value={this.state.dateFrom || ""}
                            label="Date From"
                        />
                      </Col>
                      <Col sm={2}>
                        <FormInput
                            name="dateTo"
                            className="form-control-label"
                            id="date"
                            placeholder="inputPlaceHolder.meetingReport.date"
                            type="date"
                            onChange={this.onChange}
                            value={this.state.dateTo || ""}
                            label="Date To"
                        />
                      </Col>
                      <Col md="2">
                        <FormInput
                            name="companyName"
                            className="form-control-label"
                            id="companyName"
                            placeholder="Company Name"
                            type="text"
                            onChange={this.onChange}
                            label="Company"
                            value={this.state.companyName || ""}
                            // errorMsg={this.props.errorObj?.name || ""}
                        />
                      </Col>
                      <Col md="2">
                        <FormInput
                            name="countryName"
                            className="form-control-label"
                            id="countryName"
                            placeholder="Country Name"
                            type="text"
                            onChange={this.onChange}
                            label="Country"
                            value={this.state.countryName || ""}
                            // errorMsg={this.props.errorObj?.name || ""}
                        />
                      </Col>
                      <Col sm={3} style={{marginTop:"30px"}}>
                        <Button  size="md" outline color="default" type="button" onClick={this.filterMeetingReports}>
                          Apply Filter
                        </Button>
                        <Button onClick={this.clearFilters} color="default"  size="md" outline type="button">
                          Clear Filter
                        </Button>
                      </Col>
                    </Row>
                  </CardHeader>
                  <Table className="align-items-center table-flush" responsive>
                    <thead className="thead-light">
                    <tr>
                      <th className="sort" data-sort="name" scope="col">
                        #
                      </th>
                      <th scope="col"/>
                      <th className="sort" data-sort="budget" scope="col">
                        Created On
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Date
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Company
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Country
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        EventType
                      </th>
                      <th className="sort" data-sort="status" scope="col">
                        Attendees
                      </th>

                    </tr>
                    </thead>
                    <tbody className="list">
                    {this.state.list.map(function (value, index) {
                      return (
                          <tr key={index}>
                            <td className="budget">{index + 1}</td>
                            <td className="text-right">
                              <UncontrolledDropdown>
                                <DropdownToggle
                                    color=""
                                    size="sm"
                                    className="btn-icon-only text-light"
                                >
                                  <i className="fas fa-ellipsis-v"/>
                                </DropdownToggle>
                                <DropdownMenu
                                    className="dropdown-menu-arrow"
                                    right container="body"
                                >
                                  <DropdownItem
                                      style={{display: MeetingReportPermissions.read(value?.createdBy)}}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        obj.props.history.push(
                                            `/crm/meetingReport/show/${value.uniqueId}`
                                        );
                                      }}
                                  >
                                    Details
                                  </DropdownItem>
                                  <DropdownItem
                                      style={{display: MeetingReportPermissions.update(value?.createdBy)}}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        obj.props.history.push(
                                            `/crm/meetingReport/edit/${value.uniqueId}`
                                        );
                                      }}
                                  >
                                    Edit
                                  </DropdownItem>
                                  <DropdownItem
                                      style={{display: MeetingReportPermissions.delete()}}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        obj.confirmDeleteAlert(`${value.uniqueId}`);
                                      }}
                                  >
                                    Delete
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </td>
                            <td className="budget">{formatFrontendDate(value.dateCreated)}</td>
                            <td className="budget">{formatFrontendDate(value.date)}</td>
                            <td className="budget">{value?.company?.legalName}</td>
                            <td className="budget">{value?.company?.country}</td>
                            <td className="budget">{value.eventType}</td>
                            <td className="budget">{value.attendees.map(function (value, index) {
                              return <h4 key={index} className="badge badge-lg badge-primary">{value.fullName}</h4>
                            })}</td>

                          </tr>
                      );
                    })}
                    </tbody>
                  </Table>
                </Card>
              </Col>
            </Row>
          </Container>
        </>
    );
  }
}

export default MeetingList;
